import { ValidUtils } from "../valid/ValidUtils.js";
import { Point2D } from "../entity/Point2D.js";
import { Point3D } from "../entity/Point3D.js";
import { Rect } from "../entity/Rect.js";
import { ObjectUtils } from "../object/ObjectUtils.js";
var ConvertUtils;
((ConvertUtils2) => {
  ConvertUtils2.objToGetURL = (obj) => {
    return Object.keys(obj).reduce((prev, key, i) => `${prev}${i !== 0 ? "&" : ""}${key}=${obj[key]}`, "");
  };
  ConvertUtils2.mapToJson = (map) => {
    return JSON.stringify(
      Array.from(
        map.entries()
      ).reduce((o, [key, value]) => {
        o[key] = value;
        return o;
      }, {})
    );
  };
  ConvertUtils2.jsonToMap = (jsonStr) => {
    return new Map(JSON.parse(jsonStr));
  };
  ConvertUtils2.toUrl = (data) => {
    try {
      return new URL(data);
    } catch (e) {
      throw new Error(`Invalid URL string: ${data}`);
    }
  };
  ConvertUtils2.decodeURIString = (data) => {
    return decodeURIComponent(data);
  };
  ConvertUtils2.encodeURIString = (data) => {
    return encodeURIComponent(data);
  };
  ConvertUtils2.objToStrMap = (obj) => {
    const strMap = /* @__PURE__ */ new Map();
    for (const k of Object.keys(obj)) {
      strMap.set(k, obj[k]);
    }
    return strMap;
  };
  ConvertUtils2.jsonToStrMap = (jsonStr) => {
    return ConvertUtils2.objToStrMap(JSON.parse(jsonStr));
  };
  ConvertUtils2.strToObject = (message) => {
    return JSON.parse(message);
  };
  ConvertUtils2.objToJson = (obj) => {
    return JSON.stringify(obj);
  };
  ConvertUtils2.objToMap = (obj) => {
    const mp = /* @__PURE__ */ new Map();
    Object.keys(obj).forEach((k) => {
      mp.set(k, obj[k]);
    });
    return mp;
  };
  ConvertUtils2.mapToObj = (map) => {
    const obj = {};
    map.forEach((v, k) => {
      obj[k] = v;
    });
    return obj;
  };
  ConvertUtils2.snakeToCamelCase = (str) => {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  };
  ConvertUtils2.camelToSnakeCase = (str) => {
    return str.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
  };
  function toFormData(obj) {
    const formData = new FormData();
    for (const key in obj)
      formData.append(key, obj[key]);
    return formData;
  }
  ConvertUtils2.toFormData = toFormData;
  function toObject(obj, config) {
    if (obj instanceof URLSearchParams) {
      const robj = {};
      obj.forEach((v, k) => {
        if (config?.firstValue && robj[k] === void 0) {
          robj[k] = v;
        } else if (!config?.firstValue) {
          if (robj[k]) {
            if (Array.isArray(robj[k])) {
              robj[k].push(v);
            } else {
              robj[k] = [robj[k], v];
            }
          } else {
            robj[k] = v;
          }
        }
      });
      return robj;
    } else if (obj instanceof FormData) {
      const formDataToObject = (formData) => {
        const obj2 = {};
        for (const key of formData.keys()) {
          const values = formData.getAll(key);
          obj2[key] = values.length > 1 ? values : values[0];
        }
        return obj2;
      };
      return formDataToObject(obj);
    } else if (obj && typeof obj[Symbol.iterator] === "function") {
      return Object.fromEntries(obj);
    } else if (Array.isArray(obj)) {
      return Object.fromEntries(obj);
    } else {
      if (ValidUtils.isMap(obj)) {
        const map = obj;
        obj = ConvertUtils2.mapToObj(map);
      }
      if (ValidUtils.isArray(obj)) {
        const arr = obj;
        for (let i = 0; i < arr.length; i++) {
          arr[i] = ConvertUtils2.toObject(arr[i]);
        }
      }
      if (ValidUtils.isObject(obj)) {
        for (const property in obj) {
          obj[property] = ConvertUtils2.toObject(obj[property]);
        }
      }
      return obj;
    }
  }
  ConvertUtils2.toObject = toObject;
  ;
  ConvertUtils2.toArray = (data) => {
    if (data instanceof Set) {
      return Array.from(data.values());
    }
    const datas = Array.isArray(data) ? data : data ? [data] : [];
    return datas;
  };
  ConvertUtils2.flatArray = (...data) => {
    const datas = data.flatMap((item) => item instanceof Object && Symbol.iterator in item ? Array.from(item) : [item]);
    return datas;
  };
  ConvertUtils2.iteratorToArray = (it) => {
    return Array.from(it);
  };
  ConvertUtils2.toJson = (obj) => {
    const at = ConvertUtils2.toObject(obj);
    return JSON.stringify(at);
  };
  ConvertUtils2.concatenateToAttribute = (object_o) => {
    return ConvertUtils2.concatenateToString(object_o, "=", " ", "'");
  };
  ConvertUtils2.concatenateToParameter = (object_o) => {
    return ConvertUtils2.concatenateToString(object_o, "=", "&", "");
  };
  ConvertUtils2.concatenateToString = (object_o, unionString_s = "=", spilString_s = " ", pairString_s = "") => {
    const results = [];
    for (const property in object_o) {
      const value = object_o[property];
      if (value) {
        results.push(property.toString() + unionString_s + pairString_s + value + pairString_s);
      }
    }
    return results.join(spilString_s);
  };
  ConvertUtils2.specialCharsToEscape = (data) => {
    return data.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };
  ConvertUtils2.decodeHTMLEscape = (data) => {
    return data.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&#x2F;/g, "/");
  };
  function escapeHTML(htmlString, option) {
    if (!htmlString) return "";
    const escapeMap = {
      "&": "&amp;",
      // 반드시 먼저 처리
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      // or &apos; (하지만 HTML4에서는 &#39; 권장)
      "/": "&#x2F;",
      "`": "&#x60;",
      "=": "&#x3D;",
      "{": "&#123;",
      "}": "&#125;",
      "#": "&#35;",
      "$": "&#36;",
      "\n": "&#10;",
      // newline
      "\r": "&#13;",
      // carriage return
      "	": "&#9;",
      // tab
      "\xA0": "&nbsp;",
      // non-breaking space
      "\xA2": "&cent;",
      "\xA3": "&pound;",
      "\xA5": "&yen;",
      "\u20AC": "&euro;",
      "\xA9": "&copy;",
      "\xAE": "&reg;",
      "\u2122": "&trade;",
      "\xB0": "&deg;",
      "\xB1": "&plusmn;",
      "\xD7": "&times;",
      "\xF7": "&divide;",
      "\u2212": "&minus;",
      "\u2022": "&bull;",
      "\u2026": "&hellip;",
      "\u2190": "&larr;",
      "\u2192": "&rarr;",
      "\u2191": "&uarr;",
      "\u2193": "&darr;",
      "\u2194": "&harr;"
    };
    const targetsSet = option?.targets ? new Set(option.targets) : null;
    const filteredEscapeMap = targetsSet ? Object.fromEntries(Object.entries(escapeMap).filter(([key]) => targetsSet.has(key))) : escapeMap;
    const shouldEscapeAmpersand = !targetsSet || targetsSet.has("&");
    const charsToEscape = Object.keys(filteredEscapeMap).filter((char) => char !== "&");
    if (charsToEscape.length === 0 && !shouldEscapeAmpersand) {
      return htmlString;
    }
    const escapedChars = charsToEscape.map((char) => {
      return char.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }).join("");
    let result = htmlString;
    if (shouldEscapeAmpersand) {
      result = result.replace(/&/g, "&amp;");
    }
    if (escapedChars.length > 0) {
      const regex = new RegExp(`[${escapedChars}]`, "g");
      result = result.replace(regex, (match) => {
        return filteredEscapeMap[match] || match;
      });
    }
    return result;
  }
  ConvertUtils2.escapeHTML = escapeHTML;
  ConvertUtils2.copyObject = (obj, update = {}) => {
    return { ...obj, ...update };
  };
  ConvertUtils2.copyArrayWithAddition = (arr, update) => {
    return [...arr, ...update || []];
  };
  ConvertUtils2.hexToInt = (hex) => {
    if (hex.startsWith("#")) {
      hex = hex.slice(1);
    }
    if (hex.length === 3) {
      hex = hex.split("").map((c) => c + c).join("");
    }
    return parseInt(hex, 16);
  };
  ConvertUtils2.toHex = (num) => {
    if (num < 0) {
      num = 4294967295 + num + 1;
    }
    num = Number(num.toFixed(0));
    return num.toString(16).padStart(2, "0").toUpperCase();
  };
  ConvertUtils2.toHexColor = (rgba) => {
    const r = ConvertUtils2.toHex(rgba.r ?? 0);
    const g = ConvertUtils2.toHex(rgba.g ?? 0);
    const b = ConvertUtils2.toHex(rgba.b ?? 0);
    const a = ConvertUtils2.toHex(rgba.a ?? 255);
    return `#${r}${g}${b}${a}`;
  };
  ConvertUtils2.avgColor = (color) => {
    const sum = color.reduce((acc, c) => {
      acc.r += c.r ?? 0;
      acc.g += c.g ?? 0;
      acc.b += c.b ?? 0;
      acc.a += c.a ?? 0;
      return acc;
    }, { r: 0, g: 0, b: 0, a: 0 });
    const avg = { r: Math.floor(sum.r / color.length), g: Math.floor(sum.g / color.length), b: Math.floor(sum.b / color.length), a: Math.floor(sum.a / color.length) };
    return avg;
  };
  ConvertUtils2.toRGBA = (hex) => {
    hex ?? (hex = "#000000FF");
    const hexColor = hex.replace("#", "");
    const r = parseInt(hexColor.slice(0, 2) || "0", 16);
    const g = parseInt(hexColor.slice(2, 4) || "0", 16);
    const b = parseInt(hexColor.slice(4, 6) || "0", 16);
    const a = hexColor.length > 6 ? parseInt(hexColor.slice(6, 8) || "0", 16) : 255;
    return { r, g, b, a };
  };
  ConvertUtils2.minMaxCenterAvg = (obj) => {
    const result = {};
    const allKeys = ObjectUtils.uniqueKeys(obj);
    for (const key of allKeys) {
      const values = obj.map((item) => item[key]);
      const min = Math.min(...values);
      const max = Math.max(...values);
      const center = (min + max) / 2;
      const avg = values.reduce((sum, val) => sum + val, 0) / values.length;
      result[key] = { min, max, center, avg, diff: max - min };
    }
    return result;
  };
  ConvertUtils2.minMaxCenterRectAvg2D = (point2Ds) => {
    const min = new Point2D(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
    const max = new Point2D(Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER);
    let sum = new Point2D(0, 0);
    point2Ds.forEach((p) => {
      min.x = Math.min(min.x, p.x);
      min.y = Math.min(min.y, p.y);
      max.x = Math.max(max.x, p.x);
      max.y = Math.max(max.y, p.y);
      sum.x += p.x;
      sum.y += p.y;
    });
    const center = new Point2D((min.x + max.x) / 2, (min.y + max.y) / 2);
    const avg = new Point2D(sum.x / point2Ds.length, sum.y / point2Ds.length);
    const minMaxRect = new Rect(min.x, min.y, max.x - min.x, max.y - min.y);
    return { min, max, center, avg, minMaxRect };
  };
  ConvertUtils2.minMaxCenterAvg3D = (point3Ds) => {
    const min = new Point3D(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    const max = new Point3D(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE);
    let sum = new Point3D(0, 0, 0);
    point3Ds.forEach((p) => {
      min.x = Math.min(min.x, p.x);
      min.y = Math.min(min.y, p.y);
      min.z = Math.max(min.z, p.z);
      max.x = Math.max(max.x, p.x);
      max.y = Math.max(max.y, p.y);
      max.z = Math.max(max.z, p.y);
      sum.x += p.x;
      sum.y += p.y;
      sum.z += p.z;
    });
    const center = new Point3D((min.x + max.x) / 2, (min.y + max.y) / 2, (min.z + max.z) / 2);
    const avg = new Point3D(sum.x / point3Ds.length, sum.y / point3Ds.length, sum.z / point3Ds.length);
    return { min, max, center, avg };
  };
  ConvertUtils2.roundRectRadiiToFullRadii = (radii) => {
    if (!radii) {
      return [0, 0, 0, 0];
    }
    if (radii.length === 1) {
      return [radii[0] ?? 0, radii[0] ?? 0, radii[0] ?? 0, radii[0] ?? 0];
    } else if (radii.length === 2) {
      return [radii[0] ?? 0, radii[1] ?? 0, radii[0] ?? 0, radii[1] ?? 0];
    } else if (radii.length === 3) {
      return [radii[0] ?? 0, radii[1] ?? 0, radii[2] ?? 0, radii[1] ?? 0];
    } else {
      return radii;
    }
  };
  ConvertUtils2.toArrayDirectionChange = (array) => {
    if (!array || array.length === 0 || !array[0] || array[0].length === 0) {
      return [];
    }
    const result = [];
    const numCols = array[0].length;
    const numRows = array.length;
    for (let i = 0; i < numCols; i++) {
      const newRow = [];
      for (let j = 0; j < numRows; j++) {
        newRow.push(array[j][i]);
      }
      result.push(newRow);
    }
    return result;
  };
  ConvertUtils2.groupByMap = (array, keySelector) => {
    return array.reduce((map, item) => {
      const key = keySelector(item);
      const group = map.get(key) || [];
      group.push(item);
      map.set(key, group);
      return map;
    }, /* @__PURE__ */ new Map());
  };
  ConvertUtils2.groupByObject = (array, keySelector) => {
    const map = (0, ConvertUtils2.groupByMap)(array, keySelector);
    return Object.fromEntries(map);
  };
  ConvertUtils2.toURLSearchParams = (data) => {
    const searchParams = new URLSearchParams();
    if (typeof data === "string") {
      new URLSearchParams(data).forEach((value, key) => {
        searchParams.append(key, value);
      });
    } else if (typeof data === "object") {
      const forTarget = data instanceof URLSearchParams ? data.entries() : Array.isArray(data) ? data : Object.entries(data);
      for (const [k, v] of Array.from(forTarget)) {
        if (Array.isArray(v)) {
          v.forEach((it) => searchParams.append(k, it));
        } else {
          searchParams.append(k, v);
        }
      }
    }
    return searchParams;
  };
  ConvertUtils2.toRawQueryString = (data, option) => {
    const params = ConvertUtils2.toURLSearchParams(data);
    const dataStr = Array.from(params.entries()).map(([k, v]) => {
      const j = `${k}=${option?.valueEncodeURIComponent ? encodeURIComponent(v) : v}`;
      return j;
    }).join("&");
    return dataStr;
  };
  ConvertUtils2.stringJsonToKeyPairs = (stringJson) => {
    return Array.from(stringJson.matchAll(/(\w+):\s*([^,}]+)/g)).map((match) => ({ key: match[1], value: match[2] }));
  };
  ConvertUtils2.entriesToKeyPairs = (o) => {
    return Object.entries(o).map(([key, value]) => ({ key, value }));
  };
  ConvertUtils2.stringToBase64 = (str) => {
    return btoa(str);
  };
  ConvertUtils2.uint8ArrayToBase64 = (bytes) => {
    let binary = "";
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  };
  ConvertUtils2.base64ToString = (base64) => {
    return atob(base64);
  };
  ConvertUtils2.base64ToUint8Array = (base64) => {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  };
})(ConvertUtils || (ConvertUtils = {}));
export {
  ConvertUtils
};
//# sourceMappingURL=ConvertUtils.js.map
